import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    margin: 0,
    padding: '1rem 1.25rem',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.875rem',
    borderRadius: '0.5rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
  },

  connectorsLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '1rem',
    paddingBottom: '0.75rem',

    '& span': {
      height: '2rem',
      paddingLeft: '0.5rem',
    },
  },

  headerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  headerBack: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    padding: 0,

    '& h1': {
      fontFamily: 'Sora',
      fontWeight: '400',
      fontSize: '1.5rem',
      lineHeight: '2rem',
      color: '#000000',
    },
  },

  tableBase: {
    width: '100%',
  },

  tableHeader: {
    '& th': {
      textAlign: 'left',
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      color: '#8B8D97',
    },
  },

  tableBody: {
    '& h4': {
      margin: 0,
      padding: 0,
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      marginTop: '-0.75rem',
    },
  },

  tableOrganization: {
    width: '25%',
    maxWidth: '25%',
  },

  tableConnectors: {
    width: '25%',
    maxWidth: '25%',
  },

  tableApps: {
    width: '25%',
    maxWidth: '25%',
  },

  tableProcess: {
    width: '25%',
    maxWidth: '25%',
  },

  connectors: {
    display: 'flex',
    flexDirection: 'row',
  },

  tags: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    marginTop: '-1rem',
  },
}))

export { useStyles }
